module.exports = __webpack_public_path__ + "static/offices-content-image-33-792811cadcc53619ce699859de78a39c.jpg";